<template>
  <div class="containerTim">
    <header-page :brand="brand"></header-page>

    <div class="top-banner mt-[82px] md:mt-[66px] relative">
      <banner-swiper :brand="brand"></banner-swiper>
    </div>
    <div
      class="w-full md:h-[180px] flex flex-col md:flex-row items-start md:items-center justify-center bg-[#f4f4f4] px-5 py-[70px] md:p-2"
    >
      <div class="w-[180px]">
        <img
          :src="`${$i18n.locale === 'zh' ? require('./assets/img/logo.png') : require('./assets/img/logo_en.png')}`"
          alt=""
        />
      </div>
      <div
        class="h-[3px] md:h-[100px] w-[100%] md:w-[3px] bg-[#d1d0d1] my-[24px] md:my-0 mx-0 md:mx-[28px] lg:mx-[40px]"
      ></div>
      <div
        class="text-[#111] font-[500] after:block after:w-[100px] after:h-[3px] after:bg-[#c8001e] after:mt-[5px]"
        :class="{
          'text-[20px] md:text-[24px]': $i18n.locale === 'zh',
          'text-[16px] md:text-[18px]': $i18n.locale === 'en',
        }"
      >
        {{ $t('officialDealer') }}
        <br />
        {{ $t('authorizedDealer') }}
      </div>
    </div>
    <div id="section1" class="w-full h-1"></div>
    <form-page ref="formPageRef" :brand="brand" :carList="carList" :btn="btn"></form-page>
    <footer-page :brand="brand" :phone="phone"></footer-page>
  </div>
</template>

<script>
import HeaderPage from '@/components/HeaderPage.vue'
import BannerSwiper from '@/components/BannerSwiper.vue'
import FormPage from '@/components/FormPage.vue'
import FooterPage from '@/components/FooterPage.vue'
export default {
  name: 'IcaurView',
  components: {
    HeaderPage,
    BannerSwiper,
    FormPage,
    FooterPage,
  },
  data() {
    return {
      // imageUrl: require("@/assets/img/list/7.jpg"),
      // imgsrc,
      // carouselList,
      // textList,
      btn: { btnBg: '#c8001e', btnColor: '#fff' },
      speak: '中',
      brand: {
        name: 'hongqi',
        id: 255,
      },
      phone: '2119 4889',
      carList: [
        { name: 'E-HS9' },
        { name: 'EHS5' },
        { name: 'HQ9' },
        { name: '金葵花-國禮' },
        { name: '金葵花-國耀' },
        { name: '金葵花-國雅' },
      ],
    }
  },
  computed: {},
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
@import 'element-ui/lib/theme-chalk/display.css';
.containerTim {
  font-family: 'HongqiFont', sans-serif !important;
}
::v-deep .el-select-dropdown__item {
  font-family: 'HongqiFont', sans-serif !important;
}
::v-deep .el-select-dropdown__item:hover {
  background-color: #f5f5f5;
}
::v-deep .el-select-dropdown__item.selected {
  color: #c8001e;
  // font-weight: 600;
}

.top-banner {
  width: 100%;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
